import { SendInputType } from "../interfaces/Types";

const SendInputMode: { [k: string]: SendInputType } = {
  Q: "Q",
  A: "A",
  D: "D",
};

export default SendInputMode;
